import { render, staticRenderFns } from "./activeNumberManager.vue?vue&type=template&id=86cfda12"
import script from "./activeNumberManager.vue?vue&type=script&lang=js"
export * from "./activeNumberManager.vue?vue&type=script&lang=js"
import style0 from "./activeNumberManager.vue?vue&type=style&index=0&id=86cfda12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports